import tableDesignComponent from '../../template/containerTemplateComponent/tableDesignComponent.vue';
export default {
  props: {
    tableDesignModelVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    tableDesignComponent
  },
  data() {
    return {
      //   tableDesignModelVisible: false
    };
  },
  methods: {
    handleOk() {},
    saveData(res) {
      this.$emit('update:tableDesignModelVisible', false);
      this.$emit('saveTableData', res);
    }
  }
};